import { Alert, Box, Tab, Tabs, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getClientInfo } from '../../actions/client';
import {
	shipping_info,
	billing_info,
	general_1,
	general_2,
	additionl_info,
} from '../../containers/ClientsRegister';
import { GridFieldRead } from './GridFieldRead';

export const ClientProfile = () => {
	const { idClient = null } = useParams();
	const [value, setTab] = useState(0);
	const [client, setClient] = useState(null);

	useEffect(() => {
		// Records listener
		getClientInfo(idClient).then(({ data }) => {
			setClient(data);
		});
	}, []);

	const handleChange = (_, newValue) => {
		setTab(newValue);
	};

	const tabs = [
		'Datos de facturación',
		'Contacto',
		'Datos de embarque',
		'Información adicional',
	];

	// Convert object to array
	const obj2ArrayClient = (values) => {
		let array = [];
		values = values.map((item) => ({ name: item.name, label: item.label }));

		values.forEach((item) => {
			array.push({
				label: item.label,
				value:
					String(client[item.name])?.length > 0
						? client[item.name]
						: 'Campo vacío',
			});
		});

		return array;
	};

	return (
		<Box sx={{ width: '100%' }}>
			{client ? (
				<>
					<Stack
						direction='column'
						alignItems='flex-start'
						justifyContent='space-between'
						mb={1}
						style={{
							padding: '20px 0 0 20px',
						}}
					>
						<Typography variant='h4' gutterBottom>
							{client.company_name}
						</Typography>
						<Typography variant='h6' gutterBottom>
							División: {client.division}{' '}
							{client?.type
								? `| Tipo de cliente: ${client?.type}`
								: ''}
						</Typography>
					</Stack>
					<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
						<Tabs
							value={value}
							onChange={handleChange}
							aria-label='basic tabs example'
						>
							{tabs.map((tab_name, i) => (
								<Tab
									key={tab_name}
									label={tab_name}
									{...a11yProps(i)}
								/>
							))}
						</Tabs>
					</Box>
					<TabPanel value={value} index={0}>
						<GridFieldRead
							fields={[
								...obj2ArrayClient(general_1),
								...obj2ArrayClient(billing_info),
							]}
						/>
					</TabPanel>
					<TabPanel value={value} index={1}>
						<GridFieldRead fields={obj2ArrayClient(general_2)} />
					</TabPanel>
					{/* <TabPanel value={value} index={2}>
						<GridFieldRead fields={obj2ArrayClient(billing_info)} />
					</TabPanel> */}
					<TabPanel value={value} index={2}>
						<GridFieldRead
							fields={obj2ArrayClient(shipping_info)}
						/>
					</TabPanel>
					<TabPanel value={value} index={3}>
						<GridFieldRead
							fields={obj2ArrayClient(additionl_info)}
						/>
					</TabPanel>
				</>
			) : (
				<div style={{ padding: '40px' }}>
					<Alert severity='warning'>
						No existe el usuario con ID: {idClient}
					</Alert>
				</div>
			)}
		</Box>
	);
};

const a11yProps = (index) => {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
};

const TabPanel = (props) => {
	const { children, value, index, ...other } = props;

	return (
		<div
			role='tabpanel'
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
		</div>
	);
};
